<div class="d-flex flex-column w-100 w-sm-60 mx-auto">
  <div class="d-flex flex-wrap flex-sm-nowrap container gap-3">
    <div class="d-flex flex-column col-12 col-sm-6">
      <app-ashgrid-appellation class="mb-0"></app-ashgrid-appellation>

      <div class="d-flex mt-5">
        <p class="ms-2 my-auto fw-normal" style="font-size: 56px; line-height: normal;">Email Verification</p>
      </div>
    </div>

    <div class="d-flex flex-column col-12 col-sm-6 mt-3 mt-sm-0 mxw-420px">
      <div class="d-flex mx-auto p-2e">
        <p class="mb-auto mat-headline-5 fw-bold">Check your mailbox continue</p>
      </div>

      <div class="d-flex flex-column w-100 py-5">
        <app-email-verification-cta-vector class="mx-auto"></app-email-verification-cta-vector>

        <!-- INFO Click the verification link in the mail we sent you to complete your account creation -->
        <div class="d-flex mx-auto mt-5 p-2e">
          <p class="mb-auto mat-body-1 text-center">Click the verification link in the mail we sent you to verify your email</p>
        </div>

        <!-- INFO Timer after which the page closes or routes to login -->
        <span class="mx-auto mt-4 mb-2 mat-caption">Page will close in...</span>
        <div class="d-flex mb-4">
          <span class="ms-auto mb-0 mat-headline-3 fw-bolder">{{ +minutesLeft > 9 ? minutesLeft : '0' + minutesLeft }}</span>
          <span class="mb-0 mat-headline-3 fw-bolder">:</span>
          <span class="me-auto mb-0 mat-headline-3 fw-bolder">{{ +secondsLeft > 9 ? secondsLeft : '0' + secondsLeft  }}</span>
        </div>

        <button mat-flat-button class="w-fit-content mx-auto my-4 px-3 py-4 fw-bold rounded-3e" color="primary" (click)="goToVerificationScreen()">
          <span class="my-auto mat-body-1 fw-bold">Continue (Verification)</span>
        </button>
      </div>
    </div>
  </div>
</div>
